
<ng-progress
  [color]="progressColor"
  [spinner]="false"
  [max]="85"></ng-progress>
<cc-wide-alert *ngIf="failPaid" [directPayment]="directPayment"></cc-wide-alert>
<div class="contenator" [class.alert-handle]="failPaid">
  <ndc-dynamic
    *ngIf="isVisibleMenu()"
    [ndcDynamicComponent]="leftMenuComponent"></ndc-dynamic>
  <div
    id="content"
    class="app-content h-full"
    role="main">
    <div
      ui-view
      class="app-body app-container h-full pos-rlt"></div>
  </div>
</div>

